import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {CommonService} from 'src/app/shared/utils/common.service';
import {moduloHorasExtras} from "../diccionarios/horas-extrasModulo";
import {ReemplazoEmpleadoModel} from "../model/reemplazoEmpleado.model";

@Injectable({
  providedIn: 'root'
})
export class ParametrizacionReemplazoEmpleadoService {

  diccionarioModulo: any;
  url: string;

  constructor(
    private http: HttpClient,
    private _util: UtilsService,
    private _commom: CommonService
  ) {
    this.diccionarioModulo = moduloHorasExtras;
    this.url = this._util.getUrlHorasExtra();
  }

  getAll() {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioModulo.url.parametrizacion.reeplazoEmpleado.getAll);
  }

  guardarReemplazoEmpleado(reemplazoEmpleado: ReemplazoEmpleadoModel) {
    return this._commom.peticionPostConHeader(this.url + this.diccionarioModulo.url.parametrizacion.reeplazoEmpleado.create + '', reemplazoEmpleado);
  }

  actualizarReemplazoEmpleado(reemplazoEmpleado: ReemplazoEmpleadoModel) {
    return this._commom.peticionPutConHeader(this.url + this.diccionarioModulo.url.parametrizacion.reeplazoEmpleado.update + reemplazoEmpleado.id + '', reemplazoEmpleado);
  }

  borrarReemplazoEmpleado(reemplazoEmpleado: ReemplazoEmpleadoModel) {
    return this._commom.peticionDeleteConHeader(this.url + this.diccionarioModulo.url.parametrizacion.reeplazoEmpleado.delete + reemplazoEmpleado.id + '');
  }
}
